import React from 'react';
import { Button, Dialog, Grid, Typography } from '@material-ui/core';

const ConfirmationContext = React.createContext(Promise.reject);

export const useConfirmation = () => React.useContext(ConfirmationContext);

export const ConfirmationProvider = ({ children }) => {
	const [confirm, setConfirm] = React.useState(null);

	const awaitingPromiseRef = React.useRef();

	const openConfirmation = options => {
		setConfirm(options);
		return new Promise((resolve, reject) => {
			awaitingPromiseRef.current = { resolve, reject };
		});
	};

	const handleClose = () => {
		if (confirm.catchOnCancel && awaitingPromiseRef.current) {
			awaitingPromiseRef.current.reject();
		}
		setConfirm(null);
	};

	const handleSubmit = () => {
		if (awaitingPromiseRef.current) {
			awaitingPromiseRef.current.resolve();
		}
		setConfirm(null);
	};

	return (
		<>
			<ConfirmationContext.Provider value={openConfirmation} children={children} />
			<Dialog
				open={Boolean(confirm)}
				style={{ borderRadius: 10 }}
				hideBackdrop={false}
				onClose={handleClose}
				onSubmit={handleSubmit}
			>
				<Grid
					container
					direction='column'
					alignItems='center'
					justify='center'
					style={{ padding: 36, maxWidth: 400 }}
				>
					<Typography
						style={{
							color: '#353146',
							textAlign: 'center',
							fontSize: 18,
							marginBottom: 16,
						}}
					>
						{confirm?.title || 'Are you sure?'}
					</Typography>
					<Typography
						style={{
							color: '#908BA4',
							marginBottom: 24,
							fontSize: 16,
							textAlign: 'center',
						}}
					>
						{confirm?.description || `This action won't be reverted.`}
					</Typography>
					<Grid item>
						<Button
							style={{
								marginRight: 16,
								borderRadius: 10,
								width: 100,
							}}
							size='large'
							variant='text'
							color='primary'
							onClick={handleSubmit}
							disableElevation
						>
							{confirm?.okLabel || 'Yes'}
						</Button>
						<Button
							style={{ borderRadius: 10, width: 100 }}
							variant='contained'
							size='large'
							color='secondary'
							onClick={handleClose}
							autoFocus
							disableElevation
						>
							{confirm?.cancelLabel || 'No'}
						</Button>
					</Grid>
				</Grid>
			</Dialog>
		</>
	);
};
